import { api } from "./api";


export const myAccount = api.injectEndpoints({
    endpoints: (builder) => ({
        getSettingsURL: builder.query<any, void>({
            query: () => ({
                url: "/Account/GetMyAccountSettings",
                method: "GET"
            })
        })
    })
})

export const { useGetSettingsURLQuery } = myAccount;